var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":"","lg4":"","offset-sm2":"","offset-md3":"","offset-lg4":""}},[_c('h1',{staticClass:"display-1 mb-3 mt-5"},[_vm._v("Password change required")]),_c('change-password-panel',{on:{"changed":_vm.done}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }